export default function getLastMsgContent(stream) {
  const { content_type: contentType, type, content } = stream;

  if (type === 'promotion') {
    return `[${'推广消息'}]`;
  }
  if (type === 'welcome') {
    return `[${'欢迎语'}]`;
  }

  let last_msg_content = content;

  switch (contentType) {
    case 'photo':
      last_msg_content = `[${'图片'}]`;
      break;
    case 'audio':
      last_msg_content = `[${'语音'}]`;
      break;
    case 'video':
      last_msg_content = `[${'视频'}]`;
      break;
    case 'file':
      last_msg_content = `[${'文件'}]`;
      break;
    // case 'rich_text':
    //   last_msg_content = `[${'快捷回复'}]`;
    //   break;
    case 'hybrid':
      const showContentType = ['text', 'txt'];
      const showContentMap = {
        photo_card: `[${'红包卡片'}]`,
        mini_program_card: `[${'小程序卡片'}]`
      };
      let content = {};
      try {
        content = typeof last_msg_content === 'string' ? JSON.parse(last_msg_content)[0] : last_msg_content;
      } catch (e) {}
      if (content.type && showContentType.indexOf(content.type) !== -1) {
        last_msg_content = content.body || '';
      }
      if (showContentMap[content.type]) {
        last_msg_content = showContentMap[content.type] || '';
      } else {
        last_msg_content = `[${'混合消息'}]`;
      }

      try {
        if (content.type === 'redbook_msg') {
          // 处理小红书卡片的显示
          let redbookType = content.data.content.content_type;
          if (redbookType === 'note') {
            last_msg_content = `[${'小红书笔记卡片'}]`;
          } else if (redbookType === 'common') {
            last_msg_content = `[${'小红书落地页卡片'}]`;
          } else if (redbookType === 'serviceCard') {
            last_msg_content = `[${'小红书服务卡片'}]`;
          } else if (redbookType === 'social_card') {
            last_msg_content = `[名片卡]`;
          } else if (redbookType === 'purchaseComments') {
            last_msg_content = content.data.content.content || '';
          } else if (redbookType === 'tradeBusinessCard') {
            last_msg_content = `[交易卡]`;
          }
        } else if (content.type === 'retain_consult_card') {
          last_msg_content = `[留资卡片]`;
        } else if (content.type === 'question_guide_msg_card') {
          last_msg_content = `[问题引导卡片]`;
        } else if (content.type === 'douyin_premium_online_appointment_card') {
          last_msg_content = `[高级预约卡片]`;
        } else if (content.type === 'douyin_leads_phone_card') {
          last_msg_content = `[一键收集电话]`;
        }
      } catch (e) {
      }
      break;
    default:
      break;
  }

  // 替换eval atob 粗暴一点
  return last_msg_content.replace(/eval|atob/gi, '');
}
